import { createStyles } from 'antd-style';

import { FA_SELECTOR } from '../../styles/variables';

export const useBackButtonStyles = createStyles(({ token }) => ({
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    paddingBottom: '8px',
    border: 'none',
    fontWeight: 600,
    cursor: 'pointer',
    width: 'fit-content',
    [FA_SELECTOR]: {
      fontSize: token.fontSizeLG,
      color: token.colorPrimary,
    },
  },
  backButtonLabel: {
    fontSize: token.fontSize,
    lineHeight: '17px',
    color: token.colorPrimary,
    textDecoration: 'underline',
  },
}));
